/**
 * Not used
 */
export default (kasko) => {
  kasko.addEventListener('form-changed', ({ current, previous }) => {
    const state = kasko.getState();
    if (!state.input.policy_start_month && state.input.policy_start_date) {
      kasko.dispatchEvent('set-state-input', {
        policy_start_month: state.input.policy_start_date.split('-')[1],
      });
    }

    if (
      !state.route.state.url.includes('risk-questions-2') &&
      !state.route.state.url.includes('summary')
    ) {
      return;
    }

    if (
      current &&
      previous &&
      current.policy_start_date !== previous.policy_start_date &&
      current.policy_start_date
    ) {
      kasko.dispatchEvent('set-state-input', {
        policy_start_month: current.policy_start_date.split('-')[1],
      });
    }
  });
};
